const rawApiUrl = (
  process.env.REACT_APP_API_URL || "https://yuva-backend-omega.vercel.app"
)
  .trim()
  .replace(/\/+$/, "");

// Ensure URL has protocol (http:// or https://) so browsers don't treat it as a relative path
export const API_BASE = /^https?:\/\//i.test(rawApiUrl)
  ? rawApiUrl
  : `https://${rawApiUrl}`;

export default API_BASE;
